const axios = require('axios');

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

axios.defaults.headers.common['ws-event-path'] = 'jobs_site';

function request(method, url, data, headers) {
  const dataKey = method === 'POST' || method === 'PUT' ? 'data' : 'params';
  const config = {
    method,
    url,
    [dataKey]: data,
    ...(headers && { headers }),
  };
  return axios(config)
    .then(checkStatus)
    .then((responseData) => ({ data: responseData }))
    .catch((err) => {
      let errData = {};
      let message = 'Server error';
      if (err.response && err.response.data) {
        errData = err.response.data;
        if (errData.error_code) {
          // eslint-disable-next-line
          message = errData.message;
        }
      }
      return {
        error: {
          message,
          status: err.response && err.response.status,
        },
        data: errData,
      };
    });
}

module.exports = request;
